import React from 'react';
import Carousel from './Carousel';
import FeaturedCategories from '../pages/FeaturedCategories';
import FeatureSection from '../pages/FeatureSection';
import PopularCars from '../pages/PopularCars';
import BrandSection from '../pages/BrandSection';
import RentalSteps from '../pages/RentalSteps';
import PopularRecommendation from '../pages/PopularRecommendation';
import TestimonialSection from '../pages/TestimonialSection';
import BlogSection from '../pages/BlogSection';
import FaqSection from '../pages/FaqSection';




const HeroSection = () => {
  
  return (


    <div className="th-hero-wrapper hero-1" id="hero">



 <Carousel/>
<FeaturedCategories/>
<FeatureSection/>
<PopularCars/>
{/* <BrandSection/> */}
<RentalSteps/>
{/* <PopularRecommendation/> */}
<TestimonialSection/>
<BlogSection/>
{/* <FaqSection/> */}
    </div>
  );
};

export default HeroSection;
